import { render, staticRenderFns } from "./viewstocks.vue?vue&type=template&id=65a02dc8&"
import script from "./viewstocks.vue?vue&type=script&lang=js&"
export * from "./viewstocks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports